import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, MapPin, Shield } from "lucide-react";
import SEO from "../components/SEO";

const fadeUp = { hidden: { opacity: 0, y: 24 }, visible: { opacity: 1, y: 0 } };
const stagger = { visible: { transition: { staggerChildren: 0.1 } } };

const countries = [
  {
    flag: "🇪🇸",
    name: "Espagne",
    desc: "Souscription directe à l'offre HostProtect.",
    link: "/particulier-espagne",
    testId: "choice-espagne",
  },
];

const ParticulierChoice = () => {
  return (
    <div className="min-h-screen bg-[#19294C] font-['Manrope']" data-testid="particulier-choice-page">
      <SEO
        page="home"
        customTitle="Particulier — Choisissez votre situation | HostProtect"
        customDescription="Propriétaire en location courte durée ? Choisissez votre pays pour accéder à l'offre d'assurance adaptée à votre situation."
      />

      {/* Header */}
      <header className="fixed w-full z-50 backdrop-blur-xl bg-[#19294C]/90 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-12">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center">
              <img src="/logo-hostprotect.png" alt="HostProtect" className="h-9 w-auto brightness-0 invert" />
            </Link>
            <Link
              to="/"
              className="text-sm text-white/60 hover:text-white transition-colors font-medium"
              data-testid="choice-back-btn"
            >
              Retour
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="min-h-screen flex flex-col items-center justify-center pt-24 pb-16 px-6">
        <motion.div
          className="max-w-2xl mx-auto text-center"
          initial="hidden"
          animate="visible"
          variants={stagger}
        >
          <motion.div
            className="inline-flex items-center gap-2 bg-[#00B8E4]/10 border border-[#00B8E4]/25 rounded-full px-4 py-1.5 mb-6"
            variants={fadeUp}
          >
            <MapPin className="w-3.5 h-3.5 text-[#00B8E4]" />
            <span className="text-xs font-bold text-[#00B8E4] tracking-wide">PARTICULIER</span>
          </motion.div>

          <motion.h1
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-['Outfit'] tracking-tight leading-tight"
            variants={fadeUp}
            data-testid="choice-title"
          >
            Vous êtes propriétaire en
            <br />
            <span className="bg-gradient-to-r from-[#00B8E4] to-[#2A63C5] bg-clip-text text-transparent">
              location courte durée
            </span>
          </motion.h1>

          <motion.p
            className="mt-4 text-base md:text-lg text-white/50 max-w-lg mx-auto"
            variants={fadeUp}
          >
            Choisissez votre situation pour accéder à l'offre adaptée.
          </motion.p>

          {/* Country cards */}
          <motion.div
            className="mt-10 grid grid-cols-1 gap-4 max-w-md mx-auto"
            variants={stagger}
          >
            {countries.map((c) => (
              <motion.div key={c.name} variants={fadeUp}>
                <Link
                  to={c.link}
                  className="group block rounded-2xl bg-white/[0.05] backdrop-blur-xl border border-white/15 hover:border-[#00B8E4]/50 p-6 text-center transition-all duration-300 hover:bg-white/[0.08] hover:shadow-[0_0_40px_-10px_rgba(0,184,228,0.2)]"
                  data-testid={c.testId}
                >
                  <span className="text-4xl">{c.flag}</span>
                  <h3 className="mt-3 text-lg font-bold text-white font-['Outfit']">{c.name}</h3>
                  <p className="mt-1.5 text-sm text-white/40 leading-relaxed">{c.desc}</p>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-[#00B8E4] text-sm font-semibold group-hover:gap-2.5 transition-all">
                    Continuer
                    <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                  </div>
                </Link>
              </motion.div>
            ))}
          </motion.div>

          <motion.div className="mt-8 flex items-center justify-center gap-2 text-white/25 text-xs" variants={fadeUp}>
            <Shield className="w-3.5 h-3.5" />
            <span>Assurance distribuée par PM Hospitality — Assureur Mutuaide Assistance</span>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default ParticulierChoice;
